import connectedStore from 'yola-editor/src/js/store/connected-store';
import selectors from '../selectors';

const getConceptOrBuildSlug = () => connectedStore.applySelector(selectors.getConceptOrBuildSlug);

export default getConceptOrBuildSlug;
